
<section class="editor_tiny">
  <EditorTiny
    ref="ref_editor"
    :value="content"
    @input="onInput"
  />
</section>
